// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
import "swiper/css";
import "swiper/css/free-mode";
import "swiper/css/pagination";

// Import required modules
import { Pagination } from "swiper/modules";
import { useMediaQuery } from "@mui/material";

export const Testimonials = () => {
  const isMobileScreen = useMediaQuery("(max-width: 765px)");

  return (
    <section
      className="flat-spacing-1"
      style={isMobileScreen ? { paddingBottom: 0 } : undefined}
    >
      <div className="container">
        <div className="flat-title wow fadeInUp" data-wow-delay="0s">
          <span className="title">Testimonials</span>
          {/* <p className="sub-title">
            Beat the Heat in Style: It's time to stock up on summer essentials!
          </p> */}
        </div>

        <div className="wrap-carousel">
          <Swiper
            spaceBetween={30}
            freeMode={true}
            pagination={{ clickable: true }}
            breakpoints={{
              1024: { slidesPerView: 3, spaceBetween: 30 }, // Desktop: 3 slides
              768: { slidesPerView: 2, spaceBetween: 15 }, // Tablet: 2 slides
              480: { slidesPerView: 1, spaceBetween: 15 }, // Mobile: 1 slide
            }}
            modules={[Pagination]}
            className="mySwiper"
          >
            {/* Testimonial 1 */}
            <SwiperSlide>
              <div
                className="testimonial-item style-column wow fadeInUp"
                data-wow-delay=".1s"
              >
                <div className="rating">
                  <i className="icon-start"></i>
                  <i className="icon-start"></i>
                  <i className="icon-start"></i>
                  <i className="icon-start"></i>
                  <i className="icon-start"></i>
                </div>
                <div className="heading">Melts in Your Mouth</div>
                <div className="text">
                  "The Tender Coconut Mousse Pudding is a total mood lifter—it literally melts in your mouth. I usually grab their Unnakaya or a Chicken Wheat Roll on my way home; everything is always fresh and never greasy. Definitely my favorite neighborhood spot."
                </div>
                <div className="author">
                  <div className="name">Malavika</div>
                  <div className="metas">Edappally</div>
                </div>
              </div>
            </SwiperSlide>

            {/* Testimonial 2 */}
            <SwiperSlide>
              <div
                className="testimonial-item style-column wow fadeInUp"
                data-wow-delay=".2s"
              >
                <div className="rating">
                  <i className="icon-start"></i>
                  <i className="icon-start"></i>
                  <i className="icon-start"></i>
                  <i className="icon-start"></i>
                  <i className="icon-start"></i>
                </div>
                <div className="heading">Top-Tier Snacks</div>
                <div className="text">
                  "Top-tier snacks. The Meat Puffs have a generous filling and the Uzhunnuvada is perfectly crunchy. My kids are obsessed with the Brownies, so I always make sure to grab a box whenever I'm passing through."
                </div>
                <div className="author">
                  <div className="name">Darsak Kumar</div>
                  <div className="metas">Angamaly</div>
                </div>
              </div>
            </SwiperSlide>

            {/* Testimonial 3 */}
            <SwiperSlide>
              <div
                className="testimonial-item style-column wow fadeInUp"
                data-wow-delay=".3s"
              >
                <div className="rating">
                  <i className="icon-start"></i>
                  <i className="icon-start"></i>
                  <i className="icon-start"></i>
                  <i className="icon-start"></i>
                  <i className="icon-start"></i>
                </div>
                <div className="heading">Tastes Like Home</div>
                <div className="text">
                  "Best Kinnathappam I've had in a long time—tastes exactly like home. I also picked up a tray of Chicken Quiche and Mushroom Pies for an office tea party and they were a huge hit. A great mix of traditional Kerala treats and modern bites."
                </div>
                <div className="author">
                  <div className="name">Drisya</div>
                  <div className="metas">Kakkanad</div>
                </div>
              </div>
            </SwiperSlide>
          </Swiper>

          {/* Pagination */}
          <div className="sw-dots style-2 sw-pagination-testimonial justify-content-center"></div>
        </div>
      </div>
    </section>
  );
};
